import { render, staticRenderFns } from "./AddTaskModal.vue?vue&type=template&id=1f3339be&"
import script from "./AddTaskModal.vue?vue&type=script&lang=js&"
export * from "./AddTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports